<div class="create-course">
  <div *ngIf="showSpinner" class="progress-spinner">
    <mat-spinner class="mat-spinner-color"></mat-spinner>
  </div>
  <mat-card-title class="mat-display-1 mb-5">
    <span>Projekt Erstellen</span>
  </mat-card-title>
  <div class="form">
    <mat-card>
      <mat-card-content>
        <div class="new-form">
          <form [formGroup]="projectForm" (ngSubmit)="submitForm()">
            <div class="mb-2">

              <div class="title1">
                <span class="projName">Projekttitel*</span>
                <div class="subtitle1">
                  <input class="inputTitle" formControlName="title" label="Projekttitel" placeholder="Ihr Titel hier" />
                </div>
              </div>
              <span class="note">Mindestens 4 Zeichen</span>
            </div>

            <div class="mb-2">
              <div class="titleDate">
                <span class="projName">Wann*</span>
                <div class="subtitle1">
                  <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate formControlName="start_date" placeholder="Start"
                      style="color: #fff !important" />
                    <input style="color: #fff !important" matEndDate formControlName="end_date" placeholder="End"
                      style="color: #fff !important" />
                  </mat-date-range-input>

                  <mat-datepicker-toggle style="color: #fff !important" matIconSuffix
                    [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </div>
              </div>
              <span class="note">DD/MM/YYYY - DD/MM/YYYY</span>
            </div>
            <div class="mb-2">
              <div class="title1">
                <span class="projName">Wo*</span>
                <div class="subtitle1">
                  <input class="inputTitle" formControlName="location" label="Projekttitel" placeholder="Adresse" />
                </div>
              </div>
            </div>

            <!-- SELECT LOGO -->
            <div class="mb-5">
              <ngx-dropzone
                class="selectImage"
                (change)="onSelectLogo($event)">

                <ngx-dropzone-label>
                  Projektlogo ziehen und ablegen
                </ngx-dropzone-label>

                <ngx-dropzone-preview
                  *ngFor="let f of logoFile"
                  [removable]="true"
                  (removed)="onRemoveLogo(f)">

                  <ngx-dropzone-label>
                    <img [src]="previewLogoProject" alt="{{f.name}}" class="preview-image" />
                  </ngx-dropzone-label>

                </ngx-dropzone-preview>

              </ngx-dropzone>
            </div>


            <!-- IMAGE PROJECT -->
            <div class="mb-5">
              <ngx-dropzone class="selectImage" (change)="onSelectImageProject($event)">
                <ngx-dropzone-label>Projektbild ziehen und ablegen</ngx-dropzone-label>

                <ngx-dropzone-preview *ngFor="let f of imageProject" [removable]="true"
                  (removed)="onRemoveImageProject(f)">
                  <ngx-dropzone-label>
                    <img [src]="previewProjectImage" alt="f.name" class="preview-image"
                      style="width: 100px; height: 100px; " />
                  </ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>
            </div>

            <!-- SPONSOR IMAGES -->
            <div class="mb-5">
              <ngx-dropzone class="selectImage" (change)="onSelectSponsorImage($event)">
                <ngx-dropzone-label>Ziehen und Ablegen von Sponsorenbildern</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of previewSponsorImage" [removable]="true"
                  (removed)="onRemoveSponsorImage(f)">
                  <ngx-dropzone-label class="sponsor-images">
                    <img [src]="f" alt="f.name" class="preview-image" />
                  </ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>
            </div>

            <!-- Partners Images Dropzone -->
            <div class="mb-5">
              <ngx-dropzone class="selectImage" (change)="onSelectPartnersImage($event)">
                <ngx-dropzone-label>Ziehen und Ablegen von PartnerImages</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of previewParnersImage" [removable]="true"
                  (removed)="onRemoveParnersImages(f)">
                  <ngx-dropzone-label class="sponsor-images">
                    <img [src]="f" alt="f.name" class="preview-image" />
                  </ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>
            </div>


            <div class="form-group bg-dark mb-3 content">
              <label>Beschreibung*</label>
              <app-rich-text-editor [control]="contentControl"></app-rich-text-editor>
            </div>

            <mat-card-actions>
              <button mat-raised-button color="primary" [disabled]="projectForm.invalid">
                Speichern
              </button>
            </mat-card-actions>
          </form>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card *ngIf="projectPreview$ | async as project" class="preview">
      <h1>Vorschau</h1>
      <!--  <div class="title">
                  {{project.title}}
              </div> -->
      <mat-card-header>
        <mat-card-title>{{ project.title }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="properties">
          <div *ngIf="project.start_date">
            <p class="label">Wann:</p>
            <p class="value">
              {{ project.start_date | date }} - {{ project.end_date | date }}
            </p>
          </div>
          <div *ngIf="project.location">
            <p class="label">Wo:</p>
            <p class="value">{{ project.location }}</p>
          </div>



          <!-- PROJECT LOGO -->
          <div *ngIf="project.project_icon_url && project.project_icon_url !== '' && previewLogoProject === ''">
            <p class="label">Projektlogo:</p>
            <p class="value">
              <img [src]="project.project_icon_url" alt="" />
            </p>
          </div>
          <div *ngIf="previewLogoProject !== ''">
            <p class="label">Projektlogo:</p>
            <p class="value">
              <img [src]="previewLogoProject" alt="" />
            </p>
          </div>

          <!-- PROJECT IMAGES -->
          <div *ngIf="project.project_image_url && project.project_image_url !== '' && previewProjectImage === ''">
            <p class="label">Projektbild-URL:</p>
            <p class="value">
              <img [src]="project.project_image_url" alt="" />
            </p>
          </div>
          <div *ngIf="previewProjectImage !== ''">
            <p class="label">Projektbild-URL:</p>
            <p class="value">
              <img [src]="previewProjectImage" alt="" />
            </p>
          </div>

          <!-- SPONSOR IMAGES -->
          <div
            *ngIf="project.sponsor_images_url && project.sponsor_images_url.length > 0 && previewSponsorImage.length === 0">
            <p class="label">Projektsponsor Bild-URL:</p>
            <p class="value" *ngFor="let url of project.sponsor_images_url">
              <img [src]="url" alt="" />
            </p>
          </div>
          <div *ngIf="previewSponsorImage.length !== 0">
            <p class="label">Projektsponsor Bild-URL:</p>
            <p class="value" *ngFor="let url of previewSponsorImage">
              <img [src]="url" alt="" />
            </p>
          </div>

          <!-- Partner IMAGES -->
          <div>
            <div
              *ngIf="project.partners_images_url && project.partners_images_url.length > 0 && previewParnersImage.length === 0">
              <p class="label">Projektparner Bild-URL:</p>
              <p class="value" *ngFor="let url of project.partners_images_url">
                <img [src]="url" alt="" />
              </p>
            </div>
            <div *ngIf="previewParnersImage.length !== 0">
              <p class="label">Projektpartner Bild-URL:</p>
              <p class="value" *ngFor="let url of previewParnersImage">
                <img [src]="url" alt="" />
              </p>
            </div>
          </div>

          <div *ngIf="project.director">
            <p class="label">Direktor:</p>
            <p class="value">{{ project.director }}</p>
          </div>
          <div *ngIf="project.code">
            <p class="label">Code:</p>
            <p class="value">{{ project.code }}</p>
          </div>
        </div>
        <div [innerHTML]="project.content" class="preview-content"></div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
